<template>
  <!-- 应收款明细表 -->
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-flex-right">
      <div class="cdj_div">应收款明细表-查询条件</div>
      <div class="cdj_table">
        <div class="cdj_display">
          <div class="cdj_left">
            <div class="cdj_left_display">
              <div class="cdj_left_display_background">计费周期</div>
              <div class="cdj_el-input el-date-pickers">
                <el-date-picker
                  size="mini"
                  v-model="startDate"
                  type="date"
                  placeholder="开始时间"
                ></el-date-picker>
                <span class="cdj_text_data">至</span>
                <el-date-picker
                  size="mini"
                  v-model="endDate"
                  type="date"
                  placeholder="结束时间"
                ></el-date-picker>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">缴费日期</div>
              <div class="cdj_el-input el-date-pickers">
                <el-date-picker
                  size="mini"
                  v-model="payStartDate"
                  type="date"
                  placeholder="开始时间"
                ></el-date-picker>
                <span class="cdj_text_data">至</span>
                <el-date-picker
                  size="mini"
                  v-model="payEndDate"
                  type="date"
                  placeholder="结束时间"
                ></el-date-picker>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">生成日期</div>
              <div class="cdj_el-input el-date-pickers">
                <el-date-picker
                  size="mini"
                  v-model="generateStartDate"
                  type="date"
                  placeholder="开始时间"
                ></el-date-picker>
                <span class="cdj_text_data">至</span>
                <el-date-picker
                  size="mini"
                  v-model="generateEndDate"
                  type="date"
                  placeholder="结束时间"
                ></el-date-picker>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">所属日期</div>
              <div class="cdj_el-input el-date-pickers">
                <el-date-picker
                  size="mini"
                  v-model="monthStartDate"
                  type="date"
                  placeholder="开始时间"
                ></el-date-picker>
                <span class="cdj_text_data">至</span>
                <el-date-picker
                  size="mini"
                  v-model="monthEndDate"
                  type="date"
                  placeholder="结束时间"
                ></el-date-picker>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">报表格式</div>
              <div class="cdj_el-input el-date-pickers">
                <div style="margin-top: 5px">
                  <!-- <el-radio v-model="radio" label="1">明细表</el-radio> -->
                  <el-radio v-model="radio" label="2">按房产排序</el-radio>
                </div>
              </div>
            </div>
          </div>
          <div class="cdj_left">
            <div class="cdj_left_display">
              <div class="cdj_left_display_background">房产范围</div>
              <el-select
                v-model="search"
                class="cdj_el-input"
                size="mini"
                filterable
                remote
                clearable
                reserve-keyword
                placeholder="可搜索房产/客户姓名"
                :remote-method="remoteMethod"
                :loading="loading"
              >
                <el-option
                  v-for="item in selectList"
                  :key="item.id"
                  :label="item.house"
                  :value="item.house"
                >
                </el-option>
              </el-select>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">收费项目</div>
              <div class="cdj_el-input">
                <el-select
                  v-model="data.chargeitemID"
                  multiple
                  filterable
                  collapse-tags
                  style="width: 50%"
                  placeholder="收费项目"
                >
                  <el-option
                    size="mini"
                    v-for="item in chargeitem"
                    :key="item.id"
                    :label="item.chargeItem_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <span style="cursor: pointer" @click="complete">全选</span>
                <span style="margin-left: 3px; cursor: pointer" @click="cancel"
                  >取消</span
                >
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">房间状态</div>
              <div class="cdj_el-input">
                <el-select
                  v-model="rooms"
                  multiple
                  filterable
                  collapse-tags
                  style="width: 70%"
                  placeholder="房间状态"
                >
                  <el-option
                    size="mini"
                    v-for="item in room"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
                <span style="cursor: pointer" @click="completeRoom">全选</span>
                <span
                  style="margin-left: 3px; cursor: pointer"
                  @click="cancelRoom"
                  >取消</span
                >
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">统计方式</div>
              <div class="cdj_el-input">
                <RadioGroup v-model="data.excel">
                  <Radio label="1" style="font-weight: 500">
                    按计费周期合并
                  </Radio>
                  <Radio label="2" style="font-weight: 500">
                    按计费周期明细
                  </Radio>
                  <Radio label="3" style="font-weight: 500" disabled>
                    按项目计费周期合并
                  </Radio>
                </RadioGroup>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 1px; margin-top: 10px">
        <el-button size="mini" type="primary text2" @click="searchs"
          >搜索</el-button
        >
        <el-button
          size="mini"
          type="success text2"
          style="margin-left: 1px"
          @click="excelPost"
          >导出</el-button
        >
      </div>
      <div style="display: flex; color: red; margin-top: 7px">
        <div>总金额：￥{{ money }}元</div>
      </div>
      <v-divider></v-divider>
      <v-simple-table :height="__TABLE_HEIGHT__">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">姓名</th>
              <th class="text-left">房产名称</th>
              <th class="text-left">费用周期</th>
              <th class="text-left">费用名称</th>
              <th class="text-left">生成日期</th>
              <th class="text-left">金额(实收)</th>
              <th class="text-left">调减金额(实收)</th>
              <th class="text-left">调后金额(实收)</th>
              <th class="text-left">金额(应收)</th>
              <th class="text-left">调整金额(应收)</th>
              <th class="text-left">调后金额(实收)</th>
              <th class="text-left">已缴金额</th>
              <th class="text-left">状态</th>
            </tr>
          </thead>
          <!-- 撤销 -->
          <tbody
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <tr class="text1" v-for="item in desserts" :key="item.id">
              <td>{{ item.h_name }}<span v-if="!item.h_name">--</span></td>
              <td>
                {{ item.h_name_date }}
              </td>
              <td>{{ item.startDate }}至{{ item.endDate }}</td>
              <td>
                <span v-if="item.charge_name">{{ item.charge_name }}</span
                ><span v-else>{{ item.xsc_ChargeName }}</span>
              </td>
              <td>{{ item.generate_date }}</td>
              <td>{{ item.charge }}</td>
              <td>{{ item.adjust }}</td>
              <td>{{ item.charge_after }}</td>
              <td>{{ item.chargePay }}</td>
              <td>{{ item.adjust_pay }}</td>
              <td>{{ item.charge_pay_after }}</td>
              <td>{{ item.PaidChargeSum }}</td>
              <td>
                <span v-if="item.state == 1">待支付</span
                ><span v-if="item.state == 2">已付款</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <div class="pages" v-if="desserts">
        <Page :total="total" :page-size="page" @on-change="change" show-total />
      </div>
      <div class="zhanwu" v-else>没有数据</div>
    </div>
    <excel-task
      ref="ExcelTask"
      :excelTask="excelTask"
      :excelTaskId="excelTaskId"
      @close="closeExcelTask"
    />
  </div>
</template>

<script>
import imgurl from "../../../assets/js/imgurl.js";
import HouseSearch from "@/components/common/houseSearch";
import ExcelTask from "@/components/common/excelTask";
export default {
  name: "FormsReceivables",
  components: {
    HouseSearch,
    "erp-tree": () => import("../Common/erp-tree.vue"),
    ExcelTask,
  },
  data() {
    return {
      selectList: [],
      project_id: "",
      radio: "2",
      startDate: "",
      endDate: "",
      payStartDate: "",
      payEndDate: "",
      generateStartDate: "",
      generateEndDate: "",
      monthStartDate: "",
      monthEndDate: "",
      chargeitem: [],
      chargePercentage: "",
      chargePercentage1: "",
      buttonSize: "1",
      money: "--",
      loading: false,
      desserts: "",
      total: 0,
      page: 12,
      search: "",
      state: 0,
      data: {
        pid: "",
        house_id: "",
        homeName: "",
        startDate: "",
        endDate: "",
        payStartDate: "",
        payEndDate: "",
        generateStartDate: "",
        generateEndDate: "",
        monthStartDate: "",
        monthEndDate: "",
        chargeitemID: [],
        room: [],
        excel: "1"
      },
      room: [],
      rooms: [],
      excelTaskId: null,
      excelTask: false,
    };
  },
  //界面没出来前加载
  created() {},
  // 加载数据
  mounted() {
    this.change(1);
    this.moneys();
    //加载收费大类（费项）
    this.$myhttp
      .get("admin/common/getChargeitem", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.chargeitem = backdata.data.data;
      });
    this.RoomStatus();
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  //事件
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp
          .get(
            "admin/common/house_text?text=" +
              query +
              "&project_id=" +
              this.project_id,
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
    //导出
    excelPost() {
      this.dates();
      // if(this.data.startDate == ''){
      //   this.$Message.error('计费周期开始时间不能为空');
      //   return false;
      // }
      if(this.data.pid == "" || this.data.pid == null){
        this.$Message.error('点击左边树选择房产');
        return false;
      }
      let _this = this;
      let data = this.data;
      data.radio = this.radio;
      data.targetController = "Receivables";
      data.targetFunction = "excel3";
      data.taskName = "应收款明细表";
      ERP.showLoading();
      this.$myhttp
        .post("admin/ExcelTask/addTask", data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          ERP.hideLoading();
          this.$store.commit("excelTaskAdd");
          this.$Message.success("导出任务已创建!");
          var data = backdata.data.data;
          this.excelTaskId = data.excelTaskId;
          this.openExcelTask();
        })
        .catch(function (error) {
          _this.$Message.error("数据太多了，分批导出");
          ERP.hideLoading();
        });
    },
    //全选
    complete() {
      let data = this.chargeitem;
      let id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      let idarray = "[" + id + "]";
      this.data.chargeitemID = JSON.parse(idarray);
    },
    //取消
    cancel() {
      this.data.chargeitemID = [];
    },
    //查询总欠费
    moneys() {
      if (this.data.pid == "" || this.data.pid < 0) {
        return false;
      }
      if (this.data.pid == "") {
        return true;
      }
      this.$myhttp
        .post("admin/Receivables/getMoney", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.money = backdata.data["money"];
        });
    },
    //获得当前多少页,分页
    change(e) {
      if (this.data.pid == "" || this.data.pid < 0) {
        return false;
      }
      this.dates();
      ERP.showLoading();
      this.$Loading.start();
      this.data.page = e;
      this.$myhttp
        .post("admin/Receivables/index", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          let data = backdata.data.data;
          this.desserts = data.data;
          this.total = data.count;
          this.page = data.pageSize;
          this.$Loading.finish();
          ERP.hideLoading();
        });
    },
    //时间转换
    dates() {
      this.data.startDate = "";
      this.data.endDate = "";
      this.data.payStartDate = "";
      this.data.payEndDate = "";
      this.data.generateStartDate = "";
      this.data.generateEndDate = "";
      this.data.monthStartDate = "";
      this.data.monthEndDate = "";
      if (this.startDate != null && this.startDate != "") {
        let d = this.startDate; //开始时间
        let startDate = new Date(d).getTime() / 1000;
        startDate = Number(startDate).toFixed(0);
        this.data.startDate = startDate;
      }
      if (this.endDate != null && this.endDate != "") {
        let d = this.endDate; //开始时间
        let endDate = new Date(d).getTime() / 1000;
        endDate = Number(endDate).toFixed(0);
        this.data.endDate = endDate;
      }
      if (this.payStartDate != null && this.payStartDate != "") {
        let d = this.payStartDate; //开始时间
        let payStartDate = new Date(d).getTime() / 1000;
        payStartDate = Number(payStartDate).toFixed(0);
        this.data.payStartDate = payStartDate;
      }
      if (this.payEndDate != null && this.payEndDate != "") {
        let d = this.payEndDate; //开始时间
        let payEndDate = new Date(d).getTime() / 1000;
        payEndDate = Number(payEndDate).toFixed(0);
        this.data.payEndDate = payEndDate;
      }
      if (this.generateStartDate != null && this.generateStartDate != "") {
        let d = this.generateStartDate; //开始时间
        let generateStartDate = new Date(d).getTime() / 1000;
        generateStartDate = Number(generateStartDate).toFixed(0);
        this.data.generateStartDate = generateStartDate;
      }
      if (this.generateEndDate != null && this.generateEndDate != "") {
        let d = this.generateEndDate; //开始时间
        let generateEndDate = new Date(d).getTime() / 1000;
        generateEndDate = Number(generateEndDate).toFixed(0);
        this.data.generateEndDate = generateEndDate;
      }
      if (this.monthStartDate != null && this.monthStartDate != "") {
        let d = this.monthStartDate;
        let monthStartDate = new Date(d).getTime() / 1000;
        monthStartDate = Number(monthStartDate).toFixed(0);
        this.data.monthStartDate = monthStartDate;
      }
      if (this.monthEndDate != null && this.monthEndDate != "") {
        let d = this.monthEndDate;
        let monthEndDate = new Date(d).getTime() / 1000;
        monthEndDate = Number(monthEndDate).toFixed(0);
        this.data.monthEndDate = monthEndDate;
      }
      if (this.rooms) {
        this.data.room = this.rooms
          .map((req) => {
            return req;
          })
          .join(",");
      }
    },

    //搜索
    searchs() {
      this.money = "--";
      this.change(1);
      this.moneys();
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.data.pid = data.tree[0]["id"];
      this.data.homeName = tree_str;
      // this.change(1);
      this.data.house_id = "";
      this.search = tree_str;
      if (data.tree[data.tree.length - 1].type === "room") {
        this.data.house_id = data.tree[data.tree.length - 1].id;
        this.change(1);
        this.moneys();
      }
    },
    //房态类型
    RoomStatus() {
      this.$myhttp
        .get("admin/common/room", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.room = backdata.data.data;
        });
    },
    //房态状态全选
    completeRoom() {
      let data = this.room;
      let id = data
        .map((ret) => {
          return ret.code;
        })
        .join(",");
      let idarray = "[" + id + "]";
      this.rooms = JSON.parse(idarray);
    },
    //取消
    cancelRoom() {
      this.data.room = [];
      this.rooms = [];
    },
    selectListChange(e) {
      this.selectList = e;
    },
    openExcelTask() {
      this.$store.commit("excelTaskClear");
      this.excelTask = true;
      this.$refs.ExcelTask.change(1);
    },
    closeExcelTask() {
      this.excelTask = false;
    },
  },
  watch: {
    search(e) {
      let _this = this;
      _this.data.homeName = e;
      let list = _this.selectList;
      list.map(function (it) {
        if (e == it.house) {
          _this.data.house_id = it.id;
        }
      });
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/table.css";
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin {
  margin-left: 1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Forms/receivables.vue